import React, { PureComponent } from 'react';
import { Breadcrumb, BreadcrumbItem, Container, Row } from 'reactstrap';
import { omit } from 'underscore';
import { Link } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import cx from 'classnames';

// components
import Paginator from '../../components/paginator/paginator';

// ducks
import { paginateThis, sortFields } from '../../ducks/POISearch';

// middleware
import { cleanQuery } from '../../middleware/client';

// containers
import POISearchResults from './POISearchResults';
import POISearchForm from './POISearchForm';

// modules
import BS from '../../theme/Bootstrap';
import styles from '../Containers.module.scss';

class POISearch extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  render() {
    const {
      query,
      location: { pathname }
    } = this.props;
    const { handleChange, handleSubmit } = this;
    const initialValues = omit(query, 'page', 'pageSize');
    const linkQuery = cleanQuery(query);

    return (
      <Container fluid className={styles.POISearch}>
        <Container>
          <Row>
            <Breadcrumb>
              <LinkContainer exact to="/">
                <BreadcrumbItem>
                  <Link to="/">Home</Link>
                </BreadcrumbItem>
              </LinkContainer>
              <LinkContainer exact to={this.props.pathname}>
                <BreadcrumbItem active>POI Search</BreadcrumbItem>
              </LinkContainer>
            </Breadcrumb>
          </Row>
        </Container>
        <POISearchForm
          enableReinitialize={true}
          initialValues={initialValues}
          onFilterClick={() => {
            this.setState({
              showModal: true
            });
          }}
          onChange={handleChange}
          onSubmit={handleSubmit}
          basePath={pathname}
        />

        <Row className={cx(styles.searchPagination, BS.pt3)}>
          <Container>
            <Paginator
              listId="poi"
              to={pathname}
              query={linkQuery}
              sortFields={sortFields}
              top
            />
          </Container>
        </Row>
        <Container>
          <POISearchResults listId="poi" />
        </Container>
        <Row className={cx(styles.searchPagination, BS.pt3)}>
          <Container>
            <Paginator
              listId="poi"
              to={pathname}
              query={linkQuery}
              sortFields={sortFields}
              bottom
            />
          </Container>
        </Row>
      </Container>
    );
  }

  handleChange(values, dispatch, props, previousValues) {
    clearTimeout(this.onChangeSubmitTimeout);
    if (!props.pristine) {
      this.onChangeSubmitTimeout = setTimeout(() => {
        props.submit();
      }, 100);
    }
  }

  handleSubmit(values, dispatch, props) {
    const {
      submitSearch,
      location: { pathname }
    } = this.props;

    return submitSearch({
      to: pathname,
      values: values
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.query.page !== prevProps.query.page) {
      window.scrollTo(0, 0);
    }
  }
}

const POISearchDecorated = paginateThis.decorate(POISearch, (state, props) => {
  return {
    name: ''
  };
});

POISearchDecorated.defaultProps = {
  pathname: '/find-poi'
};

export default POISearchDecorated;



// WEBPACK FOOTER //
// ./src/containers/POISearch/POISearch.js